import { connect } from 'react-redux';

import { pendoResourceCenterEnabled } from '@Containers/UserDetails/UserDetailsSelectors';
import { isAEMock, isAnonymousUser } from '../HeaderComponentSelectors';

import DashboardNavigation from './DashboardNavigation';

function mapStateToProps(state) {
  return {
    isAnonymousUser: isAnonymousUser(state),
    isAEMock: isAEMock(state),
    isPendoResourceCenterEnabled: pendoResourceCenterEnabled(state),
  };
}

export default connect(mapStateToProps)(DashboardNavigation);
